<template>
  <div>
    <Paragraph
      :content="content.content"
      v-if="content.type === 'paragraph'"
    />
    <Heading
      v-else-if="content.type === 'heading'"
      :content="content.content"
      :attrs="content.attrs"
    />
    <Blockquote
      v-else-if="content.type === 'blockquote'"
      :content="content.content"
    />
    <CodeBlock
      v-else-if="content.type === 'code_block' || content.type === 'codeBlock'"
      :content="content.content"
    />
    <BulletList
      v-else-if="content.type === 'bullet_list' || content.type === 'bulletList'"
      :content="content.content"
    />
    <HorizontalRule
      v-else-if="content.type === 'horizontal_rule' || content.type === 'horizontalRule'"
      :content="content.content"
    />
    <ImageBlock
      v-else-if="content.type === 'image' || content.type === 'custom_image'"
      :content="content"
    />
    <YoutubeBlock
      v-else-if="content.type === 'youtube'"
      :content="content"
    />
  </div>
</template>

<script>

import Blockquote from '@/components/post/Blocks/Blockquote'
import CodeBlock from '@/components/post/Blocks/CodeBlock'
import BulletList from '@/components/post/Blocks/BulletList'
import Heading from '@/components/post/Blocks/Heading'
import HorizontalRule from '@/components/post/Blocks/HorizontalRule'
import ImageBlock from '@/components/post/Blocks/ImageBlock'
import Paragraph from '@/components/post/Blocks/Paragraph'
import YoutubeBlock from '@/components/post/Blocks/YoutubeBlock'

export default {
  name: 'BaseBlock',
  props: ['content'],
  components: {
    Blockquote,
    BulletList,
    CodeBlock,
    Heading,
    HorizontalRule,
    ImageBlock,
    Paragraph,
    YoutubeBlock
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  a {
    color: $color2;

    &:hover {
      color:$color1;
    }
  }
  .style {
    display: inline;
  }

  .bold {
    font-weight: bold;;
  }

  .underline {
    text-decoration: underline;
  }

  .italic {
    font-style: italic;
  }

  .strike {
    text-decoration: line-through;
  }

  .image {
    display: block;
    width: auto;
    max-width: 100%;
    margin: 0 auto;
    -webkit-box-shadow: 0 0 10px 0 rgba(0,0,0,0.02);
    box-shadow: 0 0 10px 0 rgba(0,0,0,0.02);
    -webkit-border-radius: $radius_regular;
    -moz-border-radius: $radius_regular;
    border-radius: $radius_regular;
  }
}

</style>
